import LoginModule from '../../modules/login-module';

class Main {
	constructor() {
        this.metaDescription = document.getElementById('meta-description');
        this.loginModule = new LoginModule();
	}

	run() {
        if (!!this.metaDescription) {
            document.title = 'Behördenlogin - anabin: Infoportal zu ausländischen Bildungsabschlüssen';
            this.metaDescription.setAttribute('content', 'Zugang zur anabin-BehördenVersion für Deutsche Ministerien, nachgeordnete Behörden und anerkannte deutsche Hochschulen.');
        }
	    this.initializeModules();
	}

	initializeModules() {
        this.loginModule.tryToken().then();
	}
}
const main = new Main();
main.run();


